import { createSlice } from "@reduxjs/toolkit";

import {
	advancePlaylist,
	kioskBatchQueuePlaybacks,
	kioskDequeuePlayback,
	kioskQueuePlayback,
	proxyKioskUpdate,
	setKioskStage,
	updatePlaylist,
} from "./kiosk-action";
import {
	advancePlaylistHandler,
	kioskBatchQueuePlaybacksHandler,
	kioskDequeuePlaybackHandler,
	kioskQueuePlaybackHandler,
	proxyKioskUpdateHandler,
	setKioskStageHandler,
	updatePlaylistHandler,
} from "./kiosk-handlers";
import type { State } from "./kiosk-types";

export const initialState: State = {
	stage: "idle",
	subStage: null,
	playbackQueue: [],
	currentPlayback: null,
	playlist: [],
	playlistIdx: 0,
};

export const KioskSlice = createSlice({
	name: "Kiosk",
	initialState: initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(setKioskStage, setKioskStageHandler)
			// This handler acts as a proxy to translate raw SSE events into the high-level
			// kiosk state machine (stage and subStage). It is essential for allowing
			// the kiosk's UI to react to real-time game state transitions and other
			// backend events, ensuring the presentation layer is always in sync.
			.addCase(proxyKioskUpdate, proxyKioskUpdateHandler)
			.addCase(kioskQueuePlayback, kioskQueuePlaybackHandler)
			.addCase(kioskBatchQueuePlaybacks, kioskBatchQueuePlaybacksHandler)
			.addCase(kioskDequeuePlayback, kioskDequeuePlaybackHandler)
			.addCase(updatePlaylist, updatePlaylistHandler)
			.addCase(advancePlaylist, advancePlaylistHandler);
	},
});
